import React, { createContext, useState, useContext } from "react";

// 컨텍스트 생성
const ColorContext = createContext();

// 컨텍스트 프로바이더 컴포넌트
export const ColorProvider = ({ children }) => {
  const [color, setColor] = useState("#FFFFFF"); // 기본 색상은 검정색으로 설정

  // 색상을 변경하는 함수
  const changeColor = (newColor) => {
    setColor(newColor);
  };

  return (
    <ColorContext.Provider value={{ color, changeColor }}>
      {children}
    </ColorContext.Provider>
  );
};

// 컨텍스트를 사용하기 쉽게 하는 커스텀 훅
export const useColor = () => useContext(ColorContext);
